/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { FormControl, FormLabel, Grid } from "@mui/material";
import TextInput from "../../components/common/textInput/TextInput";
import { SelectView } from "../../components/common/selectView/SelectView";
import ButtonView from "../../components/common/button/ButtonView";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  FILTER_DROPDOWN_DATA,
  PART_KEYS,
  POSITION_DROPDOWN_DATA,
  UPDATE,
  SAVE,
} from "../../utils/GlobalConstants";
import {
  PART_ERR,
  PARTS_UPDATE_SUCCESS_MSG,
} from "../../utils/GlobalMessageConstants";
import DialogView from "../common/dialog/DialogView";
import CompetitorView from "./CompetitorView";
import { useTranslation } from "react-i18next";
import "./styles/PartForm.css";
import Loader from "../../components/common/dialog/Loader";
import { addItemInPartListUpdate } from "../../store/SurveyPageData";
import { deleteItemsFromSelectedPart } from "../../store/SurveyPageData";
import { pastePartsToVehicle } from "../../services/SurveyRequest";

const PartsForm = () => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedSurvey = useSelector(
    (state) => state?.SurveyPageData?.selectedSurvey
  );
  const selectedPart = useSelector(
    (state) => state?.SurveyPageData?.selectedPart
  );
  const selectedVehicle = useSelector(
    (state) => state?.SurveyPageData?.selectedVehicle
  );
  const [open, setOpen] = useState(false);
  const [localdata, setLocalData] = useState(PART_KEYS);
  const [addnewclicked, setaddNewClicked] = useState(false);
  const [errmsg, seterrmsg] = useState("");
  const [errPartNumber, setErrPartNumber] = useState(false);
  const [errCompetitorPartNumber, setErrCompetitorPartNumber] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [filterItem, setFilterItem] = useState();
  const [filterPosition, setFilterPosition] = useState();
  const [filterDropDownData, setFilterDropDownData] = useState();
  const [onDefault, setOnDefault] = useState(false);
  const [compFocus, setCompFocus] = useState(false);
  const [errors, setErrors]=useState(false)
  useEffect(() => {
    if (selectedVehicle?.id) {
      setaddNewClicked(true);
    }
  }, [selectedVehicle]);

  useEffect(() => {
    setFilterDropDownData(FILTER_DROPDOWN_DATA?.map(item=>({id:item?.id ,partType:item?.partType})));
    if (selectedPart?.id) {
      if (selectedPart?.partType && selectedPart?.partType !== "") {
        let filteredParts = FILTER_DROPDOWN_DATA.filter(
          (element) => element.partType === selectedPart?.partType
        );
        if (
          filteredParts !== null &&
          filteredParts !== undefined &&
          filteredParts?.length > 0
        ) {
          setFilterItem(filteredParts[0]?.id);
        } else {
          const obj = { id: 10, partType: selectedPart?.partType };
          setFilterDropDownData([...FILTER_DROPDOWN_DATA, obj]);
          setFilterItem(10);
        }
      } else {
        setFilterItem(-1);
      }

      if (selectedPart?.position) {
        let filteredParts = POSITION_DROPDOWN_DATA.filter(
          (ele) => ele.position === selectedPart?.position
        );
        setFilterPosition(filteredParts[0]?.id);
      } else {
        setFilterPosition(-1);
      }
      setLocalData(selectedPart);
      setaddNewClicked(true);
      seterrmsg("");
      setErrors(false)
      setErrCompetitorPartNumber(false);
      setErrPartNumber(false);
      setSuccessMsg("");
    } else {
      setLocalData(PART_KEYS);
      setFilterItem(-1);
      setFilterPosition(-1);
    }
  }, [selectedPart]);

  useEffect(() => {}, [filterDropDownData]);
  const handleClose = () => {
    setOpen(false);
  };

  const handleUserKeyPress = useCallback(
    (event) => {
      if (event.key === "Enter" && selectedVehicle?.id) {
        if (compFocus) {
          onSaveClick();
        } else {
          if (ref.current && ref.current.contains(event.target)) {
            onSaveClick();
          }
        }
      }
    },
    [selectedVehicle, localdata, ref]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress, selectedVehicle, localdata, ref]);

  const onAddNewPartClick = () => {
    setOnDefault(false);
    setFilterItem(-1);
    setFilterPosition(-1);
    setLocalData(PART_KEYS);
    setaddNewClicked(true);
    setSuccessMsg("");
    seterrmsg("");
    setErrPartNumber(false);
    setErrCompetitorPartNumber(false);
    dispatch(deleteItemsFromSelectedPart());
  };

  const addRecord = async (payload, msg, role) => {
    try {
      const responsePost = await pastePartsToVehicle(payload);
      if (role === UPDATE) {
        dispatch(addItemInPartListUpdate([...responsePost?.data?.id]));
      } else {
        dispatch(addItemInPartListUpdate([...responsePost?.data?.ids[0]]));
        setLocalData(PART_KEYS);
        setFilterItem(-1);
        setFilterPosition(-1);
      }
      setIsLoading(false);
      setSuccessMsg(msg);
    } catch (e) {
      setIsLoading(false);
      alert(
          Array.isArray(e?.response?.data?.message)
            ? JSON.stringify(e?.response?.data?.message[0])
            : JSON.stringify(e?.response?.data.message)
        );
    }
  };

  const handlePartFormChange = (e) => {
    if (
      e.target.value !== "" &&
      (e.target.name === "partNumber" ||
        e.target.name === "competitorPartNumber")
    ) {
      
      setErrPartNumber(false);
      setErrCompetitorPartNumber(false);
      seterrmsg("");
    }
    if( e.target.value !== "" && e.target.name === "quantity"){
      const data =Number( e.target.value)
      console.log(data,'ff',data>=1? false:true)
      setErrors(data>=1? false:true)
    }
    setLocalData({ ...localdata, [e.target.name]: e.target.value });
    setOnDefault(true);
  };

  const onHandleChangeUser = (item, selectFrom) => {
    setOnDefault(true);
    if (selectFrom === "filterType") {
      setFilterItem(item);
      setLocalData({
        ...localdata,
        partType: FILTER_DROPDOWN_DATA[item].partType,
      });
    } else {
      setFilterPosition(item);
      setLocalData({
        ...localdata,
        position: POSITION_DROPDOWN_DATA[item].position,
      });
    }
  };

  const onSaveClick = () => {
    setOnDefault(false);
    setCompFocus(false);
    let payload = {
      surveyId: selectedSurvey?.id,
      vehicleId: selectedVehicle?.id,
      partDetails: [
        {
          partType: localdata.partType,
          quantity: localdata.quantity && localdata.quantity !== "" ? localdata.quantity : 1,
          position: localdata.position,
          brand: localdata.brand,
          partNumber: localdata.partNumber,
          competitorPartNumber: localdata.competitorPartNumber,
          competitorPartBrand: localdata.competitorPartBrand,
          comments: localdata.comments,
          subPartType: localdata.subPartType,
        },
      ],
    };
    const isEmpty = Object.values(localdata).every(
      (item) => item === null || item === ""
    );

    if (selectedPart.id && !isEmpty) {
      if (
        localdata?.partNumber?.trim() !== "" ||
        localdata?.competitorPartNumber?.trim() !== ""
      ) {
        setIsLoading(true);
        seterrmsg("");
        setErrPartNumber(false);
        setErrCompetitorPartNumber(false);
        let parts = payload?.partDetails?.map((ele) => {
          return { ...ele, id: selectedPart?.id };
        });
        payload.partDetails = parts;
        addRecord(payload, PARTS_UPDATE_SUCCESS_MSG, UPDATE);
      } else {
        seterrmsg(PART_ERR);
        setErrPartNumber(true);
        setErrCompetitorPartNumber(true);
      }
    } else if (!isEmpty) {
      if (
        localdata?.partNumber?.trim() !== "" ||
        localdata?.competitorPartNumber?.trim() !== ""
      ) {
        setIsLoading(true);
        seterrmsg("");
        setErrPartNumber(false);
        setErrCompetitorPartNumber(false);
        addRecord(payload, t("tab1.messages.part_save"), SAVE);
        seterrmsg("");
        setErrPartNumber(false);
        setErrCompetitorPartNumber(false);
      } else {
        seterrmsg(PART_ERR);
        setErrPartNumber(true);
        setErrCompetitorPartNumber(true);
      }
    } else {
      setErrPartNumber(true);
      setErrCompetitorPartNumber(true);
      seterrmsg(PART_ERR);
    }
  };

  const getDataFromComp = (row) => {
    let obj, filteredList;
    if (row?.partType && row?.partType !== "") {
      filteredList = FILTER_DROPDOWN_DATA.filter(
        (element) => element.partType === row?.partType
      );
      if (filteredList && filteredList?.length > 0) {
        setFilterItem(filteredList[0]?.id);
      } else {
        obj = { id: 10, partType: row?.partType };
        setFilterDropDownData([...FILTER_DROPDOWN_DATA, obj]);
        setFilterItem(10);
      }
    } else {
      setFilterItem(-1);
    }
    let tmp = [...FILTER_DROPDOWN_DATA, obj];
    let index = 10;

    let sampleObj;
    sampleObj = {
      vehicleId: selectedVehicle?.id,
      partType:
        filteredList && filteredList?.length > 0
          ? filterDropDownData[filteredList[0]?.id]
          : tmp[index]?.partType,
      quantity: localdata?.quantity,
      position: localdata?.position,
      brand: localdata?.brand,
      partNumber: row.partNumber,
      competitorPartNumber: row.compPartNum,
      competitorPartBrand: row.compBrand,
      comments: localdata?.comments,
      subPartType: localdata?.subPartType,
    };

    setLocalData(sampleObj);
    setCompFocus(true);
  };
  return (
    <div ref={ref}>
      <DialogView
        testid="comp"
        open={open}
        maxWidth={"70em!important"}
        heading={"Interchanges"}
        handleClose={() => handleClose()}
        childComponet={
          <CompetitorView
            handleClose={handleClose}
            competitorPartNumber={localdata?.competitorPartNumber}
            getDataFromComp={getDataFromComp}
          />
        }
      />
      {successMsg !== "" && (
        <>
          <div className="successMsg">{successMsg}</div>
        </>
      )}
      {errmsg !== "" && (
        <>
          <div className="errMsg">{errmsg}</div>
        </>
      )}
      <FormControl fullWidth>
        <Grid container sx={{ padding: 0, margin: 0 }}>
          <Grid item md={5.9} sm={12} lg={5.9} xs={12}>
             <FormLabel
                htmlFor={"partNumber"}
                sx={{
                  color: errPartNumber ? "error.main" : "text.primary",
                  "& .required-asterisk": {
                    color: errPartNumber ? "error.main" : "inherit",
                  },
                }}
              >
                {t("tab1.contents.Our_Part")}
                 <span className={"required-asterisk"}> <i>(Required *)</i></span>
              </FormLabel>
            <TextField
              size="small"
              name={"partNumber"}
              required={true}
              disabled={addnewclicked ? false : true}
              value={localdata?.partNumber}
              InputLabelProps={{ shrink: localdata?.partNumber, className: "visually-hidden"  }}
              className="input-style"
              label={t("tab1.contents.Our_Part")}
              error={errPartNumber}
              onChange={handlePartFormChange}
            />
 <FormLabel
                htmlFor={ t("tab1.contents.Brand")}
                sx={{
                  color:"text.primary",
                }}
              >
                 {t("tab1.contents.Brand")}
               
              </FormLabel>
            <TextInput
              label={t("tab1.contents.Brand")}
              name={"brand"}
              disabled={addnewclicked ? false : true}
              value={localdata?.brand}
              InputLabelProps={{
                shrink: localdata?.brand,
              }}
              className="input-style"
              onChange={handlePartFormChange}
            />
          </Grid>
          <Grid item md={0.2} />

          <Grid item md={5.9} sm={12} lg={5.9} xs={12}>
            <FormLabel
                htmlFor={t("tab1.contents.Competitor")}
                sx={{
                  color: errCompetitorPartNumber ? "error.main" : "text.primary",
                  "& .required-asterisk": {
                    color: errCompetitorPartNumber ? "error.main" : "inherit",
                  },
                }}
              >
                {t("tab1.contents.Competitor")}
                { <span className={"required-asterisk"}> <i>(Required *)</i></span>}
              </FormLabel>
              
            <TextField
              testid="competitor"
              size="small"
           
              className="input-style"
              label={t("tab1.contents.Competitor")}
              name={"competitorPartNumber"}
              required={true}
              error={errCompetitorPartNumber}
              disabled={addnewclicked ? false : true}
              value={
                localdata?.competitorPartNumber
                  ? localdata?.competitorPartNumber
                  : ""
              }
              InputLabelProps={{
                className: "visually-hidden", 
                shrink: localdata?.competitorPartNumber
                  ? localdata?.competitorPartNumber
                  : "",
              }}
              onChange={handlePartFormChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon
                      className="search-icon-style"
                      onClick={() => {
                        localdata?.competitorPartNumber && setOpen(true);
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
             <FormLabel
                htmlFor={ t("tab1.contents.Competitor") + " " + t("tab1.contents.Brand")}
                sx={{
                  color:"text.primary",
                }}
              >
                 {t("tab1.contents.Competitor") + " " + t("tab1.contents.Brand")}
               
              </FormLabel>
            <TextInput
              label={
                t("tab1.contents.Competitor") + " " + t("tab1.contents.Brand")
              }
              name={"competitorPartBrand"}
              onChange={handlePartFormChange}
              disabled={addnewclicked ? false : true}
              value={
                localdata?.competitorPartBrand
                  ? localdata?.competitorPartBrand
                  : ""
              }
              InputLabelProps={{
                shrink: localdata?.competitorPartBrand
                  ? localdata?.competitorPartBrand
                  : "",
              }}
            />
          </Grid>
        </Grid>
 <FormLabel
                htmlFor={ t("tab1.contents.Quantity")}
                sx={{
                  color:"text.primary",
                }}
              >
                 {t("tab1.contents.Quantity")}
               
              </FormLabel>
        <TextInput
          label={t("tab1.contents.Quantity")}
          name={"quantity"}
          disabled={addnewclicked ? false : true}
          value={localdata?.quantity}
          onChange={handlePartFormChange}
          InputLabelProps={{
            shrink: localdata?.quantity ? localdata?.quantity : 1,
          }}
          error={errors}
          helperText={errors ? 'Value must be greater than or equal to 1':''}
        />

        <SelectView
          testid="selectfilter"
          data={filterDropDownData}
          label={t("tab1.contents.Select_Filter_Type")}
          disabled={addnewclicked ? false : true}
          onHandleChange={(item) => onHandleChangeUser(item, "filterType")}
          value={filterDropDownData && filterDropDownData[filterItem]?.id}
        />
        <SelectView
          testid="selectposition"
          data={POSITION_DROPDOWN_DATA}
          label={t("tab1.contents.Select_Position")}
          disabled={addnewclicked ? false : true}
          onHandleChange={(item) => onHandleChangeUser(item, "position")}
          value={
            POSITION_DROPDOWN_DATA && POSITION_DROPDOWN_DATA[filterPosition]?.id
          }
        />
         <FormLabel
                htmlFor={t("tab1.contents.Comments")}
                sx={{
                  color:"text.primary",
                }}
              >
                 {t("tab1.contents.Comments")}
               
              </FormLabel>
        <TextInput
          sx={{ marginBottom: "2%" }}
          label={t("tab1.contents.Comments")}
          multiline={true}
          name={"comments"}
          onChange={handlePartFormChange}
          disabled={addnewclicked ? false : true}
          value={localdata?.comments}
          InputLabelProps={{ shrink: localdata?.comments }}
        />

        <div className="button-container-parts-form">
          <ButtonView
            label={t("tab1.contents.Add_New_Part")}
            testid="addnew"
            style={{ marginRight: "10px" }}
            onClick={onAddNewPartClick}
            disabled={selectedVehicle?.id ? false : true}
          />
          <ButtonView
            testid="save"
            label={t("tab1.contents.Save")}
            disabled={ errors? true: selectedVehicle?.id?false:true}
            onClick={onSaveClick}
            className={onDefault && "btn-default-style"}
          />
        </div>
      </FormControl>
      {isLoading && <Loader className="Loader-style" />}
    </div>
  );
};

export default PartsForm;
